<ins-input
    #inputRef
    class="no-reveal"
    [type]="showPassword ? 'text' : 'password'"
    [ngModel]="currentValue"
    [readonly]="readonly"
    [disabled]="disabled!"
    [placeholder]="placeholder"
    [sklValidate]="validationKey">
</ins-input>
<span
    class="form-button align--self-center"
    [tooltip]="'ui.password.show' | translate"
    (mousedown)="onMouseDown()"
    (mouseup)="onMouseUp()">
    <skl-icon name="view" aria-hidden="true"></skl-icon>
</span>